import { fetchTicketLayout, type TicketLayout } from './api';

// Mirror of businessInfo.ts: module-level cache so the delivery modal
// doesn't refetch the layout every time an operator opens a ticket.
// Settings → save invalidates the cache so the next modal open picks up
// the new layout without a page reload.

let cached: Promise<TicketLayout | null> | undefined;
let current: TicketLayout | null = null;

async function load(): Promise<TicketLayout | null> {
  try {
    const res = await fetchTicketLayout();
    current = res.data?.layout ?? null;
    return current;
  } catch (err) {
    cached = undefined;
    throw err;
  }
}

export function getTicketLayout(): Promise<TicketLayout | null> {
  if (cached === undefined) cached = load();
  return cached;
}

export function getTicketLayoutSync(): TicketLayout | null {
  return current;
}

export function invalidateTicketLayout(): void {
  cached = undefined;
  current = null;
}
